export const ANALYTICS_COUNT_CONTRACT_VERSION = '1.0';

export const analyticsCountDefinitions = Object.freeze({
  uniqueMeldingenTotal: {
    id: 'uniqueMeldingenTotal',
    label: 'Unieke meldingen',
    description: 'Alle unieke handmatige meldingen in de huidige vestiging, gekoppeld of ter beoordeling.',
    source: 'vestigingen/{branchDocumentId}/meldingen',
    filters: ['placeholder != true', 'deleted != true', 'meldingType != automatisch'],
    deduplication: 'document-id binnen branchDocumentId',
  },
  visibleMeldingen: {
    id: 'visibleMeldingen',
    label: 'Zichtbare meldingen',
    description: 'Unieke handmatige meldingen binnen de huidige vestiging en filters.',
    source: 'vestigingen/{branchDocumentId}/meldingen',
    filters: ['placeholder != true', 'deleted != true', 'meldingType != automatisch'],
    deduplication: 'document-id binnen branchDocumentId',
  },
  manualMeldingenTotal: {
    id: 'manualMeldingenTotal',
    label: 'Handmatige meldingen totaal',
    description: 'Alle unieke handmatige meldingen binnen de huidige vestiging, inclusief review.',
    source: 'vestigingen/{branchDocumentId}/meldingen',
    filters: ['placeholder != true', 'deleted != true', 'meldingType != automatisch'],
    deduplication: 'document-id binnen branchDocumentId',
  },
  activeRobots: {
    id: 'activeRobots',
    label: 'Actieve robots',
    description: 'Actieve robotdossiers binnen de huidige vestiging.',
    source: 'vestigingen/{branchDocumentId}/robots',
    filters: ['archived != true', 'out-of-service/replaced uitgesloten door bronstatus'],
    deduplication: 'robotDocumentId',
  },
  robotsWithHistoricalResults: {
    id: 'robotsWithHistoricalResults',
    label: 'Robots met historische resultaten',
    description: 'Unieke robots die voorkomen in de getoonde meldingen, ongeacht huidige servicestatus.',
    source: 'vestigingen/{branchDocumentId}/meldingen',
    filters: ['zelfde actieve filters als zichtbare meldingen'],
    deduplication: 'robotidentiteit',
  },
  techniciansInResults: {
    id: 'techniciansInResults',
    label: 'Technici',
    description: 'Unieke technici die voorkomen in de getoonde meldingen.',
    source: 'vestigingen/{branchDocumentId}/meldingen',
    filters: ['zelfde actieve filters als zichtbare meldingen'],
    deduplication: 'genormaliseerde gebruiker',
  },
  navigationMeldingen: {
    id: 'navigationMeldingen',
    label: 'Meldingen ter beoordeling',
    description: 'Meldingen zonder betrouwbare robotkoppeling die handmatige beoordeling nodig hebben.',
    source: 'analytics linkage binnen de huidige branch',
    filters: ['placeholder != true', 'deleted != true', 'zonder betrouwbare robotkoppeling'],
    deduplication: 'melding-id',
  },
});

export function buildAnalyticsCountContract({
  sourceRecords = 0,
  visibleRecords = 0,
  manualReview = 0,
  activeRobots = 0,
  robotsWithHistoricalResults = 0,
  techniciansInResults = 0,
  updatedAt = null,
} = {}) {
  const manualTotal = Number(sourceRecords) || 0;
  return {
    version: ANALYTICS_COUNT_CONTRACT_VERSION,
    updatedAt,
    counts: {
      visibleMeldingen: Number(visibleRecords) || 0,
      uniqueMeldingenTotal: manualTotal,
      manualMeldingenTotal: manualTotal,
      manualReview: Number(manualReview) || 0,
      activeRobots: Number(activeRobots) || 0,
      robotsWithHistoricalResults: Number(robotsWithHistoricalResults) || 0,
      techniciansInResults: Number(techniciansInResults) || 0,
      navigationMeldingen: Number(manualReview) || 0,
    },
    definitions: analyticsCountDefinitions,
  };
}
